<template>
    <div class="lms__superadmin_users_bulk_actions_remove_from_groups_summary">
        <div class="columns">
            <div class="column is-narrow">
                <component-note
                    v-if="bulkActionPending"
                    :class="'lms__superadmin_users_bulk_actions_remove_from_groups_summary_leavenote'"
                >You can leave this page and come back to it later. <br>This action will run in the background while you continue to use Form.</component-note>
            </div>
        </div>
        <component-text
            :key="bulkActionCompleted"
            :class="'lms__superadmin_users_bulk_actions_remove_from_groups_summary_removingfrom'"
        >
            <template v-if="bulkActionCompleted">
                {{ usersCheckedProfileIdsLength === 1 ? 'User has' : 'Users have' }} been removed from:
            </template>
            <template v-else>
                Removing {{ usersCheckedProfileIdsLength }} {{ usersCheckedProfileIdsLength === 1 ? 'user' : 'users' }} from:
            </template>
        </component-text>
        <div class="columns">
            <div class="column">
                <form-select
                    :disabled="true"
                    :hide-input="true"
                    :get-items-getter-mapped="'getLmsSuperadminGroupsMappedLabelValue'"
                    :get-items-dispatch="'lmsSuperadminGroupsGet'"
                    :get-items-dispatch-data="loggedInWorkspaceId"
                    :item-name="['group', 'groups']"
                    :label="''"
                    :multiple="true"
                    :name="`lms-superadmin-users-bulk-actions-remove-from-groups-summary`"
                    :value="selectedGroups"
                ></form-select>
            </div>
            <div class="lms__superadmin_users_bulk_actions_remove_from_groups_summary_loadingstatus">
                <div class="column is-narrow">
                    <div class="columns is-vcentered">
                        <div class="column">
                            <div class="lms__superadmin_users_bulk_actions_remove_from_groups_summary_loadingstatus_text">
                                <template v-if="bulkActionPending">
                                    <component-text :key="'bulk-process-pending'">Updating users...</component-text>
                                </template>
                                <template v-else-if="bulkActionCompleted">
                                    <component-text :key="'bulk-process-completed'">Update complete</component-text>
                                </template>
                            </div>
                            <div class="lms__superadmin_users_bulk_actions_remove_from_groups_summary_loadingstatus_total">
                                {{ usersUpdatedProfileIds.length }} of {{ usersCheckedProfileIds.length }}
                            </div>
                        </div>
                        <div class="column">
                            <template v-if="bulkActionPending">
                                <component-icon
                                    :icon-name="'loader'"
                                    :theme="'primary'"
                                ></component-icon>
                            </template>
                            <template v-else-if="bulkActionCompleted">
                                <component-icon
                                    :icon-name="'check'"
                                    :theme="'success'"
                                ></component-icon>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <component-list
            ref="componentlist"
            :component-table="LmsSuperadminUsersBulkActionsRemoveFromGroupsSummaryTable"
            :component-table-name="'users-summary'"
            :filter-search-queryable="false"
            :filter-search-by-field="'combined'"
            :filter-select-active="false"
            :get-items-getter="'getLmsSuperadminUsersBulkActionsRemoveFromGroupsUsersChecked'"
            :item-name="['user', 'users']"
            :default-page-size="12"
        ></component-list>
    </div>
</template>

<script>
import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminUsersBulkActionsRemoveFromGroupsSummaryTable from '@/components/lms/superadmin/users/bulk/actions/removefromgroups/LmsSuperadminUsersBulkActionsRemoveFromGroupsSummaryTable'
import ComponentText from '@/components/default/shared/ComponentText'
import FormSelect from '@/components/default/forms/FormSelect'
import ComponentIcon from '@/components/default/shared/ComponentIcon'
import ComponentNote from '@/components/default/shared/ComponentNote'

export default {
  name: 'lms-superadmin-users-bulk-actions-remove-from-groups-summary',
  components: { ComponentNote, ComponentIcon, FormSelect, ComponentText, ComponentList },
  data () {
    return {
      LmsSuperadminUsersBulkActionsRemoveFromGroupsSummaryTable
    }
  },
  computed: {
    bulkActionPending () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsRemoveFromGroupsActionPending
    },
    bulkActionCompleted () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsRemoveFromGroupsActionCompleted
    },
    loggedInWorkspaceId () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId
    },
    selectedGroups () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsRemoveFromGroupsGroups
    },
    usersCheckedProfileIds () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsRemoveFromGroupsUsersCheckedProfileIds
    },
    usersUpdatedProfileIds () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsRemoveFromGroupsUsersUpdatedProfileIds
    },
    usersCheckedProfileIdsLength () {
      return this.usersCheckedProfileIds.length
    }
  },
  methods: {
    runBulkRemoveFromGroups () {
      this.$store.dispatch('lmsSuperadminUsersBulkActionsRemoveFromGroupsRun')
    },
    checkIfHasUsersChecked () {
      const usersCheckedProfileIds = this.usersCheckedProfileIds

      if (!usersCheckedProfileIds || !usersCheckedProfileIds.length) {
        this.$router.push({ name: 'lms-superadmin-user-bulk-actions-remove-from-groups-select-users' })
      }
    }
  },
  mounted () {
    this.checkIfHasUsersChecked()
    if (!this.bulkActionPending && !this.bulkActionCompleted) {
      this.runBulkRemoveFromGroups()
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersbulkactionsremovefromgroupssummary.scss";
</style>
